import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocaleService } from '../services/locale.service';
import { environment } from '../../../environments/environment';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LocaleService);
  const api = environment.apiBaseUrl || '';
  if (api && !req.url.startsWith(api) && !req.url.includes('/api/')) {
    return next(req);
  }
  const code = locale.current();
  return next(req.clone({
    setHeaders: {
      'Accept-Language': code,
      'X-Locale': code,
    },
  }));
};
